import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function Redirect() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    api.get(`/r/${slug}`)
      .then((r) => {
        setData(r.data);
        window.location.replace(r.data.wa_url);
      })
      .catch((e) => setError(errMsg(e)));
  }, [slug]);

  return (
    <div className="min-h-screen bg-ink grid place-items-center px-6 text-center">
      <div data-testid="redirect-page">
        <div className="relative mx-auto w-20 h-20">
          {!error && <span className="pulse-ring absolute inset-0 rounded-full bg-emerald-500/40" />}
          <span className={`relative grid place-items-center w-20 h-20 rounded-full ${error ? "bg-slate-800" : "bg-emerald-500"} text-slate-950`}>
            <MessageCircle className="w-9 h-9" strokeWidth={2.5} />
          </span>
        </div>
        {error ? (
          <>
            <h1 className="font-display text-2xl font-bold mt-8">Link unavailable</h1>
            <p data-testid="redirect-error" className="text-slate-400 mt-2">{error}</p>
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold mt-8">
              {data ? `Connecting you to ${data.agent_name}` : "Connecting to WhatsApp…"}
            </h1>
            <p className="text-slate-400 mt-2 text-sm">You'll be redirected in a moment.</p>
            {data && (
              <a data-testid="redirect-fallback-button" href={data.wa_url}
                className="inline-block mt-8 rounded-full bg-emerald-500 text-slate-950 px-6 py-3 font-semibold hover:bg-emerald-400 transition-colors">
                Open WhatsApp
              </a>
            )}
          </>
        )}
        <p className="font-mono text-xs text-slate-600 mt-12">powered by daddyanna</p>
      </div>
    </div>
  );
}
